<template>
  <div class="modal-outer">
    <div class="modal">
      <div class="modal-head">
        <button
          class="btn-modal-close"
          v-on:click="$emit('close')"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L19 18.9999M1 19L19 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div
          :class="[
            'title',
            {
              'title-small': !currentStage
            }
          ]"
        v-html="title">
        </div>
      </div>
      <div class="modal-body">
        <!-- 태그선택 -->
        <template v-if="currentStage === 0">
          <Tags>
            <TagItem
              v-for="tag, i in result[tagKey]"
              v-on:click="selectTag(tag.tag)"
              :selected="selectedTags.includes(tag.tag)"
              :label="tag.tag"
              :extra="`${parseInt(tag.confidence * 100)}%`"
              :key="i"
            />
          </Tags>
        </template>

        <!-- 제출확인 -->
        <template v-else-if="currentStage === 1">
          <p class="message">
            제출해주신 태그와 이미지는<br>
            기술 개선에 도움이 됩니다.
          </p>
        </template>

        <!-- 제출중 -->
        <template v-else-if="currentStage === 2">
          <div class="loader-outer">
            <div class="loader">
              <div class="outer-c"></div>
              <div class="inner-c"></div>
            </div>
          </div>
        </template>
        <template v-else-if="currentStage === 3">
          <div class="check-outer">
            <svg width="104" height="104" viewBox="0 0 104 104" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M51.9997 103.666C80.5344 103.666 103.666 80.5344 103.666 51.9997C103.666 23.465 80.5344 0.333008 51.9997 0.333008C23.465 0.333008 0.333008 23.465 0.333008 51.9997C0.333008 80.5344 23.465 103.666 51.9997 103.666ZM68.719 34.0373C70.6727 31.964 74.2938 32.3536 76.3024 34.0373C78.5455 35.9174 78.1304 39.0218 76.3024 40.9615L48.987 69.9475C47.2327 71.8091 43.1491 71.8912 41.4035 69.9475L27.6786 54.6647C25.7733 52.5431 25.5541 49.8536 27.6786 47.7404C29.5059 45.923 33.476 45.7516 35.2621 47.7404L45.2866 58.9028L68.719 34.0373Z" fill="#11BF88"/>
            </svg>
          </div>
        </template>

      </div>
      <div class="modal-footer">
        <!-- 태그선택 -->
        <template v-if="currentStage === 0">
          <Button
            size="large"
            :disabled="selectedTags.length < 1"
            v-on:click="gotoNextFromSelection"
          >
            다음
            <template v-slot:icon>
              <svgCaretRight />
            </template>
          </Button>
        </template>

        <!-- 제출확인 -->
        <template v-if="currentStage === 1">
          <div class="buttons">
            <Button
              color="accent"
              size="large"
              v-on:click="gotoSelection"
            >
              수정하기
            </Button>
            <Button
              size="large"
              v-on:click="submitTags"
            >
              다음
              <template v-slot:icon>
                <svgCaretRight />
              </template>
            </Button>
          </div>
        </template>

        <!-- 제출중 -->
        <template v-if="currentStage === 2">
          <button
            class="btn-loader"
            size="large"
          >
            <div class="btn-loader-bar" ref="progress">
            </div>
            <span>
              제출하는 중
            </span>
          </button>
        </template>

        <!-- 제출완료 -->
        <template v-if="currentStage === 3">
          <Button
            color="positive"
            size="large"
            :stretch="true"
            v-on:click="$emit('close')"
          >
            <span>
              제출 성공!
            </span>
          </Button>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/el/Button'
import svgCaretRight from '@/svg/svgCaretRight'
import Tags from '@/components/tags/Tags'
import TagItem from '@/components/tags/TagItem'
import gsap from 'gsap'
import axios from 'axios'
// currentStage
// 0 : Tags
// 1 : Confirm
// 2 : Loading
// 3 : Done

export default {
  data() {
    return {
      selectedTags: [],
      currentStage: 0,
      isLoading: false
    }
  },
  props: {
    result: [Object, Array],
    tagKey: String,
    imageUrl: String
  },
  methods: {
    selectTag(tag) {
      if (this.selectedTags.includes(tag)) {
        this.selectedTags = this.selectedTags.filter(t=> t !== tag)
      } else {
        this.selectedTags.push(tag)
      }
    },
    gotoNextFromSelection() {
      if (this.selectedTags.length < 1) return
      this.currentStage = 1
    },
    gotoSelection() {
      this.currentStage = 0
    },
    submitTags() {
      if (this.isLoading) return
      this.isLoading = true
      this.currentStage = 2
      this.$nextTick(async ()=> {
        this.isLoading = true
        await this.loadProgress()
        this.currentStage = 3
        this.isLoading = false
      })
    },
    async loadProgress() {
      await axios.post(`${this.$API_URL}/sticker_tagging/feedback`, {
        image_data: this.imageUrl,
        satisfied: false,
        satisfied_tags: this.result[this.tagKey].filter((t)=> !this.selectedTags.includes(t.tag)) || [],
        unsatisfied_tags: this.result[this.tagKey].filter((t)=> this.selectedTags.includes(t.tag)) || [],
      }, this.$API_OPTIONS)
      await gsap.fromTo(this.$refs.progress, {
        width: '0',
      }, {
        duration: 1,
        width: '100%'
      })
    }
  },
  computed: {
    title() {
      if (this.currentStage === 0) {
        return "스티커에 적합하지 않는 <br> 태그를 선택해주세요."
      }
      else if (this.currentStage === 1) {
        return "제출하시겠습니까?"
      }
      else if (this.currentStage === 2) {
        return "제출하는 중"
      }
      return "제출 완료"
    }
  },
  components: {
    Button,
    svgCaretRight,
    Tags,
    TagItem
  }
}
</script>

<style lang="scss" scoped>
.modal-outer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  display: flex;
  background-color: rgba(#000, 0.25);
  padding: 16px;
  @media screen and (max-width: 480px) {
    padding: 0;
  }
}

.modal {
  width: 100%;
  height: 100%;
  max-width: 588px;
  max-height: 760px;
  // height: auto;
  background-color: white;
  margin: auto;
  border-radius: 10px;
  box-shadow: 0px 8px 16px rgba(32, 32, 32, 0.15);
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 480px) {
    max-width: none;
    max-height: none;
    border-radius: 0;
  }
}

.modal-head {
  position: relative;
  padding: 18px 16px 16px;
  display: flex;
  align-items: center;
  &:after {
    position: absolute;
    bottom: 0;
    content: '';
    left: 40px;
    right: 40px;
    height: 1px;
    border-top: 1px solid #E0E0E0;
  }
  @media screen and (max-width: 600px) {
    display: block;
  }
}

.modal-body {
  padding: 30px 40px;
  flex: 1;
  overflow: auto;
}
.modal-footer {
  padding: 0 40px 30px;
  display: flex;
  justify-content: flex-end;

  button {
    width: 180px;
  }
}
.modal-head .title {
  text-align: center;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: var(--gray-900);
  margin: 0 auto;
  padding-right: 48px;
  @media screen and (min-width: 601px) {
    br {
      display: none;
    }
  }
  @media screen and (max-width: 600px) {
    &.title-small {
      font-size: 20px;
      line-height: 28px;
    }
    text-align: center;
    width: 100%;
    padding-right: 0;
  }
}

.modal-head .btn-modal-close {
  cursor: pointer;
  display: flex;
  width: 48px;
  height: 48px;
  background-color: white;
  border-radius: 5px;
  border: 0;
  outline: 0;
  svg {
    display: block;
    width: 15px;
    height: auto;
    margin: auto;
  }
}

.modal-footer .buttons {
  display: flex;
  gap: 8px;
}

p.message {
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  margin: 0;
  color: var(--gray-700);
}

.loader-outer {
  width: 100%;
  height: 100%;
  display: flex;
}

.check-outer {
  width: 100%;
  height: 100%;
  display: flex;
  svg {
    margin: auto;
  }
}

.loader {
  margin: auto;
  position: relative;
  width: 104px;
  height: 104px;
  animation: spin 2s linear infinite;
}
.loader .outer-c {
  position: relative;
  background: conic-gradient(from 180deg at 50% 50%, #F9876B 0deg, rgba(249, 135, 107, 0) 360deg);
  border-radius: 50%;
  width: 100%;
  height: 100%;
  z-index: 1;
  &:after {
    position: absolute;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background-color: var(--primary-500);
    content: '';
    bottom: 0;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
  }
}

.loader .inner-c {
  position: absolute;
  top: 13px;
  right: 13px;
  bottom: 13px;
  left: 13px;
  background-color: white;
  border-radius: 50%;
  z-index: 2;
}

@keyframes spin {
  0% {
    transform: rotate(0)
  }
  100% {
    transform: rotate(-360deg)
  }
}

.modal-footer .btn-loader {
  position: relative;
  width: 100%;
  height: 56px;
  font-size: 20px;
  font-weight: 600;
  font-family: "Red Hat Display";
  color: #FFF;
  background-color: var(--primary-400);
  border: 1px solid var(--primary-400);
  border-radius: 8px;
  padding: 0 4px;
  overflow: hidden;
  span {
    position: relative;
    z-index: 3;
  }
}

.btn-loader-bar {
  position: absolute;
  // border-radius: 8px;
  background-color: var(--primary-500);
  z-index: 1;
  top: 0;
  left: 0;
  bottom: 0;
}
</style>